import ClassNames from "classnames";
import * as React from "react";
import IconLoading from "../_assets/icon-loading.svg";
import Styles from "./Button.module.css";
export interface Props {
  type?: "button" | "submit" | "reset";
  children: any;
  id?: string;
  variant?: "solid" | "outlined" | "text" | "inverted" | "destructive";
  ariaLabel?: string;
  className?: string;
  compact?: boolean;
  disabled?: boolean;
  loading?: boolean;
  inlineIcon?: JSX.Element;
  iconPosition?: "leading" | "trailing";
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onBlur?: (e: React.FocusEvent<HTMLButtonElement>) => void;
  inputRef?: any;
  fullWidth?: boolean;
}

const Button: React.FC<Props> = props => {
  const {
    ariaLabel,
    id,
    children,
    className,
    compact = false,
    disabled,
    loading = false,
    inlineIcon = false,
    iconPosition,
    onClick,
    onBlur,
    inputRef,
    type = "button",
    variant = "solid",
    fullWidth = false
  } = props;

  return (
    <button
      id={id}
      className={ClassNames({
        [Styles.button]: true,
        [Styles[variant]]: true,
        [Styles.compact]: compact,
        [Styles.fullWidth]: fullWidth,
        [className]: className
      })}
      disabled={loading === true ? true : disabled}
      aria-label={ariaLabel}
      onClick={onClick}
      onBlur={onBlur}
      ref={inputRef}
      type={type}
    >
      <span className={loading ? "block invisible h-0" : ""}>
        {inlineIcon && iconPosition === "leading" && (
          <span className={Styles.leadingIcon}>{inlineIcon}</span>
        )}
        {children}
        {inlineIcon && iconPosition === "trailing" && (
          <span className={Styles.trailingIcon}>{inlineIcon}</span>
        )}
      </span>
      {loading && <IconLoading className={Styles.loadingIcon} is="svg" />}
    </button>
  );
};

export default Button;
